var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipsCardPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 13.7502C28.875 23.3752 16.5 31.6252 16.5 31.6252C16.5 31.6252 4.125 23.3752 4.125 13.7502C4.125 10.4682 5.42879 7.32056 7.74955 4.9998C10.0703 2.67903 13.2179 1.37524 16.5 1.37524C19.7821 1.37524 22.9297 2.67903 25.2504 4.9998C27.5712 7.32056 28.875 10.4682 28.875 13.7502Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.8752C18.7782 17.8752 20.625 16.0284 20.625 13.7502C20.625 11.4721 18.7782 9.62524 16.5 9.62524C14.2218 9.62524 12.375 11.4721 12.375 13.7502C12.375 16.0284 14.2218 17.8752 16.5 17.8752Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsCardPinIcon);
export default __webpack_public_path__ + "static/media/tips-card-pin-icon.b897d8fe78fca4a714fc636d5a3d4719.svg";
export { ForwardRef as ReactComponent };